import { motion } from "framer-motion";

export const easeLux = [0.25, 1, 0.5, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 26 },
  show: { opacity: 1, y: 0, transition: { duration: 1, ease: easeLux } },
};

export function Reveal({ children, delay = 0, y = 26, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-12%" }}
      transition={{ duration: 1, ease: easeLux, delay }}
    >
      {children}
    </motion.div>
  );
}

/* Masked line-by-line reveal for headings */
export function MaskLines({ lines, className = "", delay = 0, stagger = 0.12 }) {
  return (
    <span className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.2em] -mb-[0.12em]">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.2, ease: easeLux, delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
